const openDataURL = process.env.VUE_APP_OpenData_Base_Resource_URL;
const openDataToken = process.env.VUE_APP_OpenData_APP_TOKEN;
const miEconomyApi = process.env.VUE_APP_API_URL;

export async function GetSpotlight() {
    const url = `${miEconomyApi}Metrics/Featured`;
    console.log(url)
    try {
        const resp = await fetch(url,{method:"GET"});
        if (resp.status == 200) {
            return await resp.json();
        } else {
            if (resp.status == 400) {
                console.log("400 response - Bad token!");
            } else {
                console.log(`${resp.status} response - Unknown`)
            }

            alert("Error fetching spotlight");
            return [];
        }        
    } catch (error) {
        console.log(error);
    }

}

export async function GetMetricData(code:string){
    const url = `${openDataURL}${code}.json`;
    const resp =  await fetch(url,{
        method:'GET',
        headers: {
            'X-App-Token': openDataToken
        }
    });

    if (resp.status == 200) {
        return await resp.json();
    } else {
        if (resp.status == 400) {
            console.log("400 response - Bad token!");
        } else {
            console.log(`${resp.status} response - Unknown`)
        }

        alert("Error fetching metric");
        return [];
    }
}